import { __decorate } from "tslib";
import { Component } from 'decorators';
import template from './EmptyPropertiesComponent.view.html';
let EmptyPropertiesComponent = class EmptyPropertiesComponent {
    //#endregion
    $onInit() {
        // Component initialization logic if needed
    }
};
EmptyPropertiesComponent = __decorate([
    Component({
        template,
        bindings: {
            showEmptyState: '<',
            onAddProperty: '&',
            isDisabledToAdd: '<?',
        },
    })
], EmptyPropertiesComponent);
export { EmptyPropertiesComponent };
